export default __webpack_public_path__ + "static/logo-white-4a15eede79a9d7123fe449360853ee7f.svg";